"use client";

import { DialogComponent } from "../../../DialogComponent";
import { useState } from "react";
import { TextResources } from "@portal/assets/text/TextResources";

import Button from "@portal/components/atoms/v2/buttons/button";
import Checkbox from "@portal/components/atoms/v2/checkbox";
import Typography from "@portal/components/atoms/v2/typography";
import useCustomerAgreementsForLoggedInCustomer from "@portal/hooks/useCustomerAgreementsForLoggedInCustomer";
import Link from "next/link";
import Icon from "@portal/components/atoms/icons";

const CustomerAgreementDialog = () => {
  const [confirmAgreement, setConfirmAgreement] = useState(false);
  const [confirmError, setConfirmError] = useState("");
  const [confirmLoading, setConfirmLoading] = useState(false);
  const { confirmUpdatedAgreement, isAgreementOutOfDate, isLoading, mutateTerms } = useCustomerAgreementsForLoggedInCustomer();

  const onConfirmUpdatedCustomerAgreement = async () => {
    setConfirmLoading(true);
    if (!confirmAgreement) {
      setConfirmError(TextResources.UPDATED_TERMS_CONFIRM_ERROR_TEXT);
      setConfirmLoading(false);
      return;
    }
    await confirmUpdatedAgreement();
    await mutateTerms();
    setConfirmLoading(false);
  };

  return (
    <DialogComponent
      open={isAgreementOutOfDate && !isLoading}
      panelClassName="top-10 w-full md:w-5/6 h-5/6 rounded-lg bg-white border border-greyBorder p-4"
      onClose={() => {}}
    >
      <div className="flex flex-col space-y-5 h-full">
        <Typography variant="H5">{TextResources.UPDATED_TERMS_TITLE}</Typography>
        <Typography>{TextResources.UPDATED_TERMS_TEXT}</Typography>
        <Link
          className="flex text-blueHighlighted items-center space-x-1 sm:hidden"
          href="https://norne.no/wp-content/uploads/2024/12/Norne-Alminnelige-forretningsvilkar_nov.pdf"
          download={TextResources.UPDATED_TERMS_DOCUMENT_TITLE}
          target="_blank"
          prefetch={false}
        >
          <Typography>{TextResources.UPDATED_TERMS_SHOW_NEW_TERMS_TEXT}</Typography>
          <Icon name="arrowTopRightOnSquareIcon" size="xsmall" />
        </Link>

        <iframe
          className="h-5/6"
          title="Vilkår"
          src="https://norne.no/wp-content/uploads/2024/12/Norne-Alminnelige-forretningsvilkar_nov.pdf"
        />
        <div>
          <Checkbox
            id="confirmAgreement"
            isChecked={confirmAgreement}
            onChange={() => {
              setConfirmError("");
              setConfirmAgreement(!confirmAgreement);
            }}
          >
            {TextResources.UPDATED_TERMS_CONFIRM_TEXT}
          </Checkbox>
        </div>
        {confirmError && <Typography variant="Error">{confirmError}</Typography>}
        <div className="flex justify-end">
          <Button
            loading={confirmLoading ? 1 : 0}
            primary
            text={TextResources.UPDATED_TERMS_BUTTON_TEXT}
            onClick={onConfirmUpdatedCustomerAgreement}
          />
        </div>
      </div>
    </DialogComponent>
  );
};

export default CustomerAgreementDialog;
